import { createSlice } from '@reduxjs/toolkit'
import { getToken } from '../services/LocalStorageService'

// Seed the store synchronously from sessionStorage so a page reload/deep
// link doesn't briefly (or permanently) look logged-out before any
// component has a chance to dispatch setUserToken.
const initialState = {
  access_token: getToken().access_token || null,
}

export const authSlice = createSlice({
  name: 'auth_token',
  initialState,
  reducers: {
    setUserToken: (state, action) => {
      state.access_token = action.payload.access_token
    },
    unSetUserToken: (state, action) => {
      state.access_token = action.payload.access_token
    },
  },
})

export const { setUserToken, unSetUserToken } = authSlice.actions

export default authSlice.reducer